import { Command } from '@ckeditor/ckeditor5-core';
import { first } from '@ckeditor/ckeditor5-utils';
import LinkModal from '../../link-modal';
export default class InsertExpertTipCommand extends Command {
    refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    execute(options) {
        try {
            const publications = this.editor.config.get('internalLink.publications') || [];
            const linkModal = new LinkModal([
                {
                    description: '',
                    subTitle: '',
                    id: null,
                    linkType: 'author',
                    publicationId: null,
                    title: 'Without author',
                },
                ...publications.filter(({ linkType }) => linkType === 'author'),
            ], { searchPlaceholder: 'Author name' });
            linkModal.show().then((authorItem) => {
                const model = this.editor.model;
                const schema = model.schema;
                const selection = model.document.selection;
                const blocks = Array.from(selection.getSelectedBlocks());
                const value = !options || options.forceValue === undefined ? !this.value : options.forceValue;
                model.change((writer) => {
                    if (!value) {
                        this._removeExpertTip(writer, blocks.filter(findExpertTip));
                    }
                    else {
                        const blocksToExpertTip = blocks.filter((block) => {
                            return findExpertTip(block) || checkCanBeExpertTiped(schema, block);
                        });
                        this._applyExpertTip(writer, blocksToExpertTip, authorItem);
                    }
                });
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = first(selection.getSelectedBlocks());
        return !!(firstBlock && findExpertTip(firstBlock));
    }
    _checkEnabled() {
        if (this.value) {
            return true;
        }
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = first(selection.getSelectedBlocks());
        if (!firstBlock) {
            return false;
        }
        return checkCanBeExpertTiped(schema, firstBlock);
    }
    _removeExpertTip(writer, blocks) {
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) {
                writer.split(groupRange.end);
            }
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    _applyExpertTip(writer, blocks, authorItem) {
        const tipsToMerge = [];
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            let expertTip = findExpertTip(groupRange.start);
            if (!expertTip) {
                expertTip = writer.createElement('expertTip', authorItem.publicationId
                    ? {
                        authorId: authorItem.publicationId,
                    }
                    : undefined);
                writer.wrap(groupRange, expertTip);
                if (authorItem.publicationId) {
                    const authorNameElement = writer.createElement('expertTipAuthorName');
                    writer.appendText(authorItem.title, authorNameElement);
                    writer.append(authorNameElement, expertTip);
                    const authorDescElement = writer.createElement('expertTipAuthorDesc');
                    writer.appendText(authorItem.description, authorDescElement);
                    writer.append(authorDescElement, expertTip);
                    writer.setAttribute('class', 'expert-tip_with-author', expertTip);
                }
            }
            tipsToMerge.push(expertTip);
        });
        tipsToMerge.reverse().reduce((currentExpertTip, nextExpertTip) => {
            if (currentExpertTip.nextSibling == nextExpertTip) {
                writer.merge(writer.createPositionAfter(currentExpertTip));
                return currentExpertTip;
            }
            return nextExpertTip;
        });
    }
}
function findExpertTip(elementOrPosition) {
    var _a;
    return ((_a = elementOrPosition === null || elementOrPosition === void 0 ? void 0 : elementOrPosition.parent) === null || _a === void 0 ? void 0 : _a.name) == 'expertTip' ? elementOrPosition.parent : null;
}
function getRangesOfBlockGroups(writer, blocks) {
    let startPosition = null;
    let i = 0;
    const ranges = [];
    while (i < blocks.length) {
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) {
            startPosition = writer.createPositionBefore(block);
        }
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
function checkCanBeExpertTiped(schema, block) {
    const isExpertTipAllowed = schema.checkChild(block.parent, 'expertTip');
    const isBlockAllowedInExpertTip = schema.checkChild(['$root', 'expertTip'], block);
    return isExpertTipAllowed && isBlockAllowedInExpertTip;
}
